import {
  createIssueAttributeAction,
  updateIssueAttributeAction,
  resetHighlightingRowsAction,
  changeLocationAction
} from '../../../app/actions';
import {
  getCurrentEditingIssueAttribute,
  getIssueAttributesDefinitionTypesCount,
  isUpdatingIssueAttributesDefinition,
  isCreatingIssueAttributesDefinition,
  isIssueAttributeDefinitionsModalOpen
} from '../../../app/selectors';
import {connect} from '../../../app/connect';
import IssueAttributesAdminEditModal from './IssueAttributesAdminEditModal';

const mapStateToProps = state => ({
  definitionTypesCount: getIssueAttributesDefinitionTypesCount(state),
  isSaving: isUpdatingIssueAttributesDefinition(state) || isCreatingIssueAttributesDefinition(state),
  currentIssueAttribute: getCurrentEditingIssueAttribute(state),
  isOpen: isIssueAttributeDefinitionsModalOpen(state)
});

const mapDispatchToProps = {
  createIssueAttributeAction,
  updateIssueAttributeAction,
  resetHighlightingRowsAction,
  changeLocationAction
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueAttributesAdminEditModal);
